<template>
  <div class="warp">
    <BaseHeader />

    <main v-if="!isExp">
      <SideLeft />

      <div id="payment">
        <figure v-if="!section">
          <div class="topic text-blue titillium-sb">{{ text.paymentType }}</div>
          <form>
            <ul class="container-check">
              <li v-for="(pm, index) in payment_methods" :key="index">
                <label :class="{ text_deactive: pm.disabled, 'b-check': true }">
                  <input
                    type="radio"
                    name="chooies"
                    :value="pm.paymentType"
                    :disabled="pm.disabled"
                    v-model="selectedMethod"
                  />
                  <span class="checkmark"></span>
                  <div class="text">
                    <p class="titillium-r">{{ pm.description }}</p>
                  </div>
                  <em v-html="pm.icon"></em>
                </label>
              </li>
            </ul>
          </form>
        </figure>

        <a
          v-if="!section"
          :class="{ deactive: !selectedMethod, 'btn titillium-sm': true }"
          :disabled="!selectedMethod"
          @click="set_section()"
          >{{ text.nextButton }} <em></em
        ></a>

        <figure v-if="section && paymentBy.length > 0">
          <div class="topic second text-blue titillium-sb">
            {{ text.paymentBy }}
          </div>
          <div class="pass">
            <div class="bank">
              <div class="text">
                <p v-if="language == 'TH'" class="titillium-r">
                  {{ paymentBy[0].description_th }}
                </p>
                <p v-else class="titillium-r">
                  {{ paymentBy[0].description_en }}
                </p>
              </div>
              <p
                v-if="paymentBy[0].paymentType == 'CreditQR'"
                class="titillium-r"
              >
                <em v-html="paymentBy[0].icon_qr_credit"></em>
              </p>
              <p
                v-else-if="paymentBy[0].paymentType == 'PPCS'"
                class="titillium-r"
              >
                <em v-html="paymentBy[0].icon_qr_credit"></em>
              </p>
              <p v-else class="titillium-r">
                <em v-html="paymentBy[0].icon"></em>
              </p>
            </div>
            <div v-if="paymentBy.length" class="change-payment titillium-r">
              <a href="javascript:;" @click="changePaymentMethod()">{{
                text.changePaymentMethod
              }}</a>
            </div>
          </div>

          <div class="total-card">
            <!-- QR CODE -->
            <div
              v-if="
                paymentGroup0.includes(selectedMethod) ||
                paymentGroup1.includes(selectedMethod)
              "
              class="content"
            >
              <!-- <h4>{{ text.headQr }}</h4> -->
              <!-- <i class="titillium-r">{{ text.headQrdesc }}</i> -->
              <div
                class="text-center"
                style="padding: 0 15%; padding-bottom: 0px"
              >
                <v-img
                  id="download-qr"
                  :src="qrcode"
                  style="background-color: white"
                />
                <a
                  v-if="
                    (section &&
                      paymentBy.length > 0 &&
                      paymentGroup0.includes(selectedMethod)) ||
                    paymentGroup1.includes(selectedMethod)
                  "
                  class="btn titillium-sm mt-3"
                  style="padding-right: 46px"
                  @click="downloadQR()"
                >
                  {{ text.btndownloadQR }}</a
                >
              </div>
            </div>

            <!-- SCB Easy -->
            <div v-if="paymentGroup3.includes(selectedMethod)" class="content">
              <div
                class="text-center"
                style="padding: 0 15%; padding-bottom: 0px"
              >
                <img
                  src="/images/ic_scb_easy.jpg"
                  alt="ic_scb_easy"
                  style="width: 100%"
                />
              </div>
            </div>

            <!-- INSTALLMENT -->
            <div
              v-if="paymentGroup7.includes(selectedMethod)"
              class="content installment-section"
            >

              <div class="install-label">
                <span class="payment-title titillium-r">
                  {{ text.selectBank }}
                </span>
              </div>

              <div class="bank-grid">

                <div
                  v-for="bank in installmentBanks"
                  :key="bank.id"
                  class="bank-card"
                  :class="{
                    active:selectedInstallmentBank===bank.bank_code
                  }"
                  @click="
                    selectedInstallmentBank=bank.bank_code;
                    selectedInstallmentTerm=null;
                  "
                >
                  <img
                    :src="getInstallmentLogo(bank.bank_code)"
                    class="install-bank-logo"
                  />
                  <div class="bank-name">
                    {{
                      language === 'TH'
                        ? bank.bank_name_th
                        : bank.bank_name_en
                    }}
                  </div>
                </div>

              </div>

              <div v-if="selectedInstallmentBank">

                <div
                  class="install-label titillium-r"
                  style="margin-top:20px;"
                >
                  {{ text.selectTerm }}
                </div>

                <div class="term-grid">

                  <div
                    v-for="
                      term in
                      getSelectedTerms()
                    "
                    :key="term"
                    class="term-card"
                    :class="{
                      active:selectedInstallmentTerm===term
                    }"
                    @click="
                      selectedInstallmentTerm=term
                    "
                  >
                    {{ term }} {{ text.installmentMonth }}
                  </div>
                </div>
              </div>
            </div>

            <!-- APPSWITCH -->
             <div
              v-if="paymentGroup8.includes(selectedMethod)"
              class="content installment-section"
            >

              <div class="install-label">
                <span class="payment-title titillium-r">
                  {{ text.selectBank }}
                </span>
              </div>

              <div class="bank-grid">

                <div
                  v-for="bank in appswitchBanks"
                  :key="bank.id"
                  class="bank-card"
                  :class="{
                    active:selectedAppswitchBank===bank.bank_code
                  }"
                  @click="
                    selectedAppswitchBank=bank.bank_code;
                  "
                >
                  <img
                    :src="getAppswitchLogo(bank.bank_code)"
                    class="install-bank-logo"
                  />
                  <div class="bank-name">
                    {{
                      language === 'TH'
                        ? bank.bank_name_th
                        : bank.bank_name_en
                    }}
                  </div>
                </div>

              </div>
            </div>



            <!-- FOOTER -->
            <div class="top">
              <label class="titillium-r">{{ text.Total }}</label>
              <p class="titillium-r text-blue">{{ total }}</p>
            </div>

            <!-- CREDIT -->
            <div v-if="paymentGroup2.includes(selectedMethod)" class="content">
              <label class="titillium-r" @click="floatbind()">{{
                text.amountTotal
              }}</label>
              <p v-if="!paymentBy[0].splitCard" class="titillium-r text-blue">
                {{ amountCreditText }}
              </p>
              <v-text-field
                v-if="paymentBy[0].splitCard"
                style="text-align: right !important"
                id="amountCredit"
                outline
                v-model="amountCreditText"
                label="จำนวนเงิน"
                placeholder="จำนวนเงิน"
                single-line
                @blur="inpAmountCredit"
              ></v-text-field>
              <!-- :key="maxLengthKey" -->
              <!-- type="number" -->
              <!-- v-model="amountCredit" -->
              <!-- @blur="checkAmount"  -->
              <div class="text-center">
                <i
                  v-if="paymentBy[0].splitCard"
                  class="titillium-r"
                  style="text-align: center"
                  >{{ text.headCreditdesc }}</i
                >
                <i
                  v-if="
                    amountCredit != total_price &&
                    paymentGroup2.includes(selectedMethod)
                  "
                  class="titillium-r"
                  style="color: #0d6efd"
                  @click="fullPaid"
                  >{{ text.fullpaid }}</i
                >
              </div>
            </div>
            <div class="bottom">
              <label class="titillium-r">{{ text.outstanding }}</label>
              <p class="titillium-r">{{ outstanding_Decimal }}</p>
            </div>
          </div>
        </figure>
        <div id="kpayment" ref="kpayment"></div>
        <div id="kpaywechat" ref="kpaywechat"></div>
        <!-- <div v-if="paymentToken">
          <h3>Token: {{ paymentToken }}</h3>
          <pre>{{ paymentResponse }}</pre>
        </div> -->
        <a
          v-if="
            section &&
            paymentBy.length > 0 &&
            paymentGroup2.includes(selectedMethod) &&
            (selectedMethod != 'KCreditCard' && selectedMethod != 'KSmartPay')
          "
          :class="{
            deactive: maxLengthCheck && amountCredit < 0,
            'btn titillium-sm': true,
          }"
          :disabled="maxLengthCheck && amountCredit < 1"
          @click="sendPayment()"
        >
          {{ text.nextButton }} <em></em
        ></a>

        <div
          v-if="
            selectedInstallmentBankInfo &&
            selectedInstallmentTerm
          "
          class="install-summary"
        >
          {{ text.installmentVia }}

          {{
            language === 'TH'
              ? selectedInstallmentBankInfo.bank_name_th
              : selectedInstallmentBankInfo.bank_name_en
          }}

          {{ selectedInstallmentTerm }}

          {{ text.installmentMonth }}
        </div>

        <a
          v-if="
            section &&
            paymentBy.length > 0 &&
            paymentGroup7.includes(selectedMethod)
          "
          :class="{
            deactive:
              !selectedInstallmentBank ||
              !selectedInstallmentTerm,
            'btn titillium-sm': true
          }"
          :disabled="
            !selectedInstallmentBank ||
            !selectedInstallmentTerm
          "
          @click="sendInstallment()"
        >
          {{ text.nextButton }}
          <em></em>
        </a>

        <a
          v-if="
            section &&
            paymentBy.length > 0 &&
            paymentGroup8.includes(selectedMethod)
          "
          :class="{
            deactive:
              !selectedAppswitchBank ,
            'btn titillium-sm': true
          }"
          :disabled="
            !selectedAppswitchBank
          "
          @click="sendAppswitch()"
        >
          {{ text.nextButton }}
          <em></em>
        </a>

        <a
          v-if="
            section &&
            paymentBy.length > 0 &&
            paymentGroup4.includes(selectedMethod)
          "
          :class="{
            deactive: maxLengthCheck && amountCredit < 0,
            'btn titillium-sm': true,
          }"
          :disabled="maxLengthCheck && amountCredit < 1"
          @click="sendDeeplink()"
        >
          {{ text.nextButton }} <em></em
        ></a>

         <a
          v-if="
            section &&
            paymentBy.length > 0 &&
            paymentGroup6.includes(selectedMethod) &&
            (selectedMethod != 'KWeChat')
          "
          :class="{
            deactive: maxLengthCheck && amountCredit < 0,
            'btn titillium-sm': true,
          }"
          :disabled="maxLengthCheck && amountCredit < 1"
          @click="sendCreateCharge()"
        >
          {{ text.nextButton }} <em></em
        ></a>

      </div>
    </main>
    <main v-else>
      <div class="col-lg-6 offset-lg-3">
        <div class="card-v2">
          <div class="card-head-v2">
            <p class="text-center pm-amount">
              <svg
                width="22"
                height="22"
                viewBox="0 0 22 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="11" cy="11" r="11" fill="#AB2328" />
                <path
                  d="M9.992 17V9H12.136V17H9.992ZM9.992 7.976V5.8H12.136V7.976H9.992Z"
                  fill="white"
                />
              </svg>
              {{ text.linkExp }}
            </p>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>
<style>
.v-input__slot {
  margin-bottom: 0px !important;
}
.remark {
  margin-bottom: 20px;
  color: #004071;
}
.installment-section {
  display: block !important;
  width: 100%;
}

.payment-title {
  font-size: clamp(20px, 2vw, 24px);
  line-height: 1.4;
  font-weight: 400;
}

.install-label {
  width: 100% !important;
  float: none !important;
  padding-left: 0 !important;
  margin-bottom: 16px;

  font-size: 24px;
  line-height: 32px;
  font-weight: 400;
}

.bank-grid,
.term-grid {
  display: grid !important;
  gap: 12px;
  width: 100%;
  margin-top: 12px;
}

/* ธนาคาร */
.bank-grid {
  grid-template-columns: repeat(3, 1fr);
}

/* งวด */
.term-grid {
  grid-template-columns: repeat(3, 1fr);
}

.bank-card,
.term-card {
  background: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 10px;
  padding: 14px 10px;
  text-align: center;
  cursor: pointer;
  transition: all 0.2s ease;
  user-select: none;
  font-size: 14px;
  color: #303131;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  min-height: 100px;
}

.bank-card:hover,
.term-card:hover {
  border-color: #004071;
}

.bank-card.active,
.term-card.active {
  border: 2px solid #004071;
  background: #eef6ff;
  color: #004071;
  font-weight: 600;
}

.install-bank-logo {
  width: 56px;
  height: 56px;
  object-fit: contain;
  margin-bottom: 8px;
}

.bank-name {
  font-size: 14px;
  font-weight: 500;
  text-align: center;
}

.install-summary {
  margin-top: 15px;
  padding: 12px;
  border-radius: 8px;
  background: #eef6ff;
  color: #004071;
  text-align: center;
  font-weight: 600;
}

@media (max-width: 768px) {
  .bank-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .term-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>
<script>
import * as moment from 'moment'
import { mapState } from 'vuex'
import domtoimage from 'dom-to-image'
export default {
  mounted() {
    //console.log('pm mounted')
    /* if (
      sessionStorage.getItem('linkcode') ||
      localStorage.linkcode == this.$route.query.linkcode
    ) {
      // check Expire date
      let checkExpire = setInterval(() => {
        const exp = moment(this.$store.state.expire).toDate()
        if (exp.getTime() <= new Date().getTime()) {
          this.isExp = true
          this.dialog = true
          this.$router.push(
            `/paymentExpired/?linkcode=${this.$route.query.linkcode}`
          )
          clearInterval(checkExpire)
        }
      }, 30000)
    } else {
      this.$router.push(`/authen/?linkcode=${this.$route.query.linkcode}`)
    } */
    //Fix Expire
    const exp = moment(this.$store.state.expire).toDate()
    const diff = exp.getTime() - Date.now()

    if (diff > 0) {
      this.expireTimer = setTimeout(() => {
        this.$router.push(`/paymentExpired/?linkcode=${this.$route.query.linkcode}`)
      }, diff)
    }

    const linkcodes = this.$route.query.linkcode.split('?')
    this.$route.query.linkcode = linkcodes[0]
    this.$store.dispatch('getBillData', {
      linkcode: this.$route.query.linkcode,
      page: 'paymentmethods',
    })
    //this.checkData()

    // ดัก callback event ไว้ก่อนเลย
    window.addEventListener('kpayment:complete', (event) => {
      //console.log('Payment Success:', event.detail)
      this.paymentToken = event.detail.id
      this.paymentResponse = event.detail

      // ส่ง token ไป backend
      //this.sendTokenToServer(event.detail.id)
    })

    window.addEventListener('kpayment:error', (event) => {
      console.error('Payment Error:', event.detail)
    })
  },
  data() {
    return {
      selectedMethod: null,
      isExp: false,
      dialog: false,
      section: '',
      /*
      ThaiQR        /qr/ThaiQR/?linkcode=LETOLE,
      CreditCard    /paymentInput/CreditCard/?linkcode=LETOLE,
      CreditUnion   /credit/CreditUnion/?linkcode=LETOLE,
      CreditQR      /qr/CreditQR/?linkcode=LETOLE,
      WeChat        /qr/WeChat/?linkcode=LETOLE,
      Alipay        /qr/Alipay/?linkcode=LETOLE,
      SCB Easy      /scbeasy/SCB Easy/?linkcode=LETOLE,
      */
      paymentBy: {},
      paymentGroup0: ['ThaiQR', 'KThaiQR', 'PPCS'],
      paymentGroup1: ['CreditQR', 'KCreditQR', 'Alipay', 'AlipayPlus', 'WeChat'],
      paymentGroup2: ['CreditCard', 'CreditUnion', 'KCreditCard','KSmartPay'],
      paymentGroup3: ['SCB Easy'],
      paymentGroup4: ['MobileBanking', 'MobileBanking_UAT'],
      paymentGroup5: ['PayPlus'], //Add Payplus method 04/02/2026
      paymentGroup6: ['KAlipay','KWeChat'],
      paymentGroup7: ['InstallCrossbank'],
      paymentGroup8: ['AppswitchCrossbank'],

      // CREDTI CARD
      minPay: {
        amount: 0,
        disabled: false,
      },
      billBankLength: 0,
      maxLengthKey: 0,
      maxLengthCheck: true,
      amountCreditText: '',
      amountFloatCreditText: true,
      checkEbillDone: null,
      apiKey: '',
      mid: '',
      shopName: 'BDMS Payment Gateway',
      paymentToken: null,
      paymentResponse: null,

      //Installment crossbank
      selectedInstallmentBank : null, 
      selectedInstallmentTerm : null, 
      installmentBanks: [] ,

      //Appswitch crossbank
      selectedAppswitchBank : null, 
      appswitchBanks: [] 
    }
  },
  created() {
    this.getBanks()

    // this.checkEbillDone = setInterval(() => {
    //   //console.log('pm polling')
    //   //Fix Check Expire
    //   /* const exp = moment(this.$store.state.expire).toDate()
    //   if (exp.getTime() <= new Date().getTime()) {
    //     this.$router.push(
    //       `/paymentExpired/?linkcode=${this.$route.query.linkcode}`
    //     )
    //     clearInterval(this.checkEbillDone)
    //   } */

    //   if (this.$store.state.outstanding == 0) {
    //     clearInterval(this.checkEbillDone)
    //   } else {
    //     if (
    //       !this.paymentGroup2.includes(this.selectedMethod) &&
    //       this.$route.name == 'paymentMethods'
    //     ) {
    //       this.$store.dispatch('getBillData_v1', {
    //         linkcode: this.$route.query.linkcode,
    //         page: 'paymentmethods',
    //       })
    //     }
    //   }
    // }, 10000)
  },

  beforeDestroy() {
    //console.log('clear interval paymentMethods')
    // if (this.checkEbillDone) {
    //   clearInterval(this.checkEbillDone)
    // }

    if (this.billStatus) {
      clearInterval(this.billStatus)
    }

    if (this.expireTimer) {
      clearTimeout(this.expireTimer)
    }
  },

  methods: {
    floatbind() {
      return false
      if (this.amountFloatCreditText) {
        this.amountFloatCreditText = false
      } else {
        this.amountFloatCreditText = true
      }
      //console.log(this.amountFloatCreditText)
    },
    inpAmountCredit() {
      if (this.amountFloatCreditText) {
        this.fncMaxLenFloat()
      } else {
        this.fncMaxLength()
      }
    },
    amountCreditToText() {
      var num = 0
      var arr = String(this.amountCredit).split('')
      var out = new Array()
      for (var cnt = 0; cnt < arr.length; cnt++) {
        if (isNaN(arr[cnt]) == false) {
          out.push(arr[cnt])
        }
      }
      num = Number(out.join(''))
      //this.amountCreditText = num.toLocaleString()
      //Fixed currency changes according to region
      this.amountCreditText = num.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    },
    fncMaxLength() {
      this.maxLengthCheck = false
      this.amountCredit = parseFloat(this.amountCreditText.replace(/,/g, ''))
      if (this.amountCredit > this.total_price) {
        this.amountCredit = this.total_price
      }
      this.amountCreditToText()
      this.maxLengthKey++
      this.maxLengthCheck = true
    },

    /* amountCreditToTxtFloat() {
      var num = 0
      var amountCredit = this.amountCreditText.split('.')
      var arr = String(amountCredit[0]).split('')
      var out = new Array()
      for (var cnt = 0; cnt < arr.length; cnt++) {
        if (isNaN(arr[cnt]) == false) {
          out.push(arr[cnt])
        }
      }
      num = Number(out.join(''))
      this.amountCreditText = num.toLocaleString()
      if (amountCredit[1]) {
        this.amountCreditText = num.toLocaleString() + '.' + amountCredit[1]
      }
    }, */

    amountCreditToTxtFloat() {
      let raw = this.amountCreditText || ''

      //ลบทุกอย่างที่ไม่ใช่ตัวเลขและจุด
      raw = raw.replace(/[^0-9.]/g, '')

      //แปลงเป็นตัวเลข float (ถ้าเป็น "" ให้เป็น 0)
      let num = parseFloat(raw)
      if (isNaN(num)) num = 0

      //แปลงกลับเป็น string แบบคงที่ (ไม่พึ่ง region)
      this.amountCreditText = num.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    },
    fncMaxLenFloat() {
      // if (this.timer) {
      //     clearTimeout(this.timer);
      //     this.timer = null;
      // }
      // this.timer = setTimeout(() => {
      this.maxLengthCheck = false
      var get_float = this.amountCreditText.split('.')
      if (get_float.length > 1) {
        if (get_float[1].length > 2)
          this.amountCreditText = get_float[0] + '.' + get_float[1].substr(0, 2)
        if (get_float[1].length == 1)
          this.amountCreditText = get_float[0] + '.' + get_float[1] + '0'
      } else {
        this.amountCreditText = this.amountCreditText + '.00'
      }
      this.amountCredit = parseFloat(this.amountCreditText.replace(/,/g, ''))
      if (this.amountCredit > this.total_price) {
        this.amountCredit = this.total_price
        this.amountCreditText = this.total_price + '.00'
      }
      this.amountCreditToTxtFloat()
      this.maxLengthKey++
      this.maxLengthCheck = true
      // }, 2500);
    },
    changePaymentMethod() {
      this.section = ''

      this.selectedInstallmentBank = null
      this.selectedInstallmentTerm = null

      this.fullPaid()

      // หยุด interval ก่อน
      if (this.billStatus) {
        clearInterval(this.billStatus)
        this.billStatus = null
      }

      const container = document.getElementById('kpayment')
      if (container) container.innerHTML = ''

      const containerwechat = document.getElementById('kpaywechat')
      if (containerwechat) containerwechat.innerHTML = ''

    },
    async set_section() {
      //Fix Check Expire
      if (this.checkExpireNow()) return
      this.loading = true
      this.section = this.selectedMethod

      this.paymentBy = this.payment_methods.filter((res) => {
        return res.paymentType == this.selectedMethod
      })
      if (this.paymentGroup0.includes(this.selectedMethod)) {
        this.genQr()
      } else if (this.paymentGroup1.includes(this.selectedMethod)) {
        this.genQr()
      } else if (this.paymentGroup2.includes(this.selectedMethod)) {
        if (this.amountFloatCreditText) {
          if (
            Number(this.amountCredit) === this.amountCredit &&
            this.amountCredit % 1 === 0
          ) {
            this.amountCreditText = this.amountCredit + '.00'
            this.fncMaxLenFloat()
          } else {
            this.amountCreditText = this.amountCredit + ''
          }
          this.fncMaxLenFloat()
        } else {
          this.amountCreditToText()
        }

        if (this.selectedMethod === 'KCreditCard' || this.selectedMethod === 'KSmartPay' ) {
          this.loadKBankScript()
        }
        // sendPayment
      } else if (this.paymentGroup3.includes(this.selectedMethod)) {
        // this.genScbLink()
        window.location.href = this.route
      } else if (this.paymentGroup4.includes(this.selectedMethod)) {
        // sendDeeplink
      } else if (this.paymentGroup5.includes(this.selectedMethod)) {
        //window.location.href = this.route
        this.$router.push(this.route)
      } else if (this.paymentGroup6.includes(this.selectedMethod)) {

        if (this.selectedMethod === 'KWeChat') {
          this.loadWechatPaynow()
        }
        //this.sendCreateCharge()
      } else if (this.paymentGroup7.includes(this.selectedMethod)) {
        this.amountCreditText =this.amountCredit + '.00'
        if (this.installmentBanks.length === 0) {
          await this.loadInstallmentBanks()
        }
      } else if(this.paymentGroup8.includes(this.selectedMethod)){
        this.amountCreditText =this.amountCredit + '.00'
        if (this.appswitchBanks.length === 0) {
          await this.loadAppswitchBanks()
        }
      }
    },

    genQr() {
        this.billStatus = setInterval(() => {
        if (this.$route.name == 'paymentMethods') {
          this.$store
            .dispatch('getBillDataStatus', this.$route.query.linkcode)
            .then(() => {
              if (this.$store.state.billDataStatus != 2) {
                let page =
                  this.$store.state.billDataStatus <= 3
                    ? 'paymentMethods'
                    : // : 'billRecieve'
                      'paymentSuccess'
                clearInterval(this.billStatus)
                this.$router.push(
                  `/${page}/?linkcode=${this.$route.query.linkcode}`
                )
              }
            })
        }
      }, 30000)
      if (this.$store.state.billBank) {
        var bank = this.$store.state.billBank.filter((item) => {
          return item.paymentType == this.selectedMethod
        })
        if (bank.length > 0) {
          let qr = {}
          switch (this.selectedMethod) {
            case 'CreditQR':
              this.method = 'คิวอาร์ เครดิต'
              break
            case 'ThaiQR':
              this.method = 'คิวอาร์ เพย์เมนต์'
              break
            case 'WeChat':
              this.method = 'WeChat Pay'
              qr.trantype = 'W'
              break
            case 'Alipay':
              this.method = 'Ali Pay'
              qr.trantype = 'A'
              break
            case 'AlipayPlus':
              this.method = 'Ali Pay Plus'
              qr.trantype = 'X'
              break
            case 'PPCS':
              this.method = 'PPCS'
              break
          }
          qr.method = this.selectedMethod
          qr.refcode = this.$store.state.linkcode
          qr.amount = this.$store.state.amount
          qr.bubankid = bank[0].id
          qr.updateQr = this.$store.state.qr
          this.$store.dispatch('getQR', qr)
        }
      } else {
        this.$router.push(
          '/paymentMethods/?linkcode=' + this.$route.query.linkcode
        )
      }
      this.loading = false
    },
    downloadQR() {
      this.loading = true
      // console.log('element '+ document.getElementById('download-qr'))
      // console.log('selectedMethod ' + this.selectedMethod)

      domtoimage
        .toJpeg(document.getElementById('download-qr'), {
          quality: 0.95,
        })
        .then((dataUrl) => {
          var link = document.createElement('a')
          let urlString = window.location.href
          link.download = urlString.split('?')[1].split('=')[1] + '.jpeg'
          link.href = dataUrl
          link.click()
          this.loading = false
        })
    },

    checkData() {
      try {
        if (
          sessionStorage.getItem('linkcode') ||
          localStorage.linkcode == this.$route.query.linkcode
        ) {
          const exp = moment(this.$store.state.expire).toDate()
          if (exp.getTime() <= new Date().getTime()) {
            this.isExp = true
            this.dialog = true
            this.$router.push(
              `/paymentExpired/?linkcode=${this.$route.query.linkcode}`
            )
            clearInterval(this.checkEbillDone)
          } else if (
            this.$store.state.billData.status > 3 &&
            this.$store.state.billData.total == this.$store.state.billData.paid
          ) {
            this.$router.push(
              `/billRecieve/?linkcode=${this.$route.query.linkcode}`
            )
          }
          if (this.$store.state.billBank.length == 1) {
            this.nextSkip()
          }
        } else {
          this.$router.push(`/authen/?linkcode=${this.$route.query.linkcode}`)
        }
      } catch (error) {
        // console.log(error)
        this.autoNext()
      }
    },
    onLinkExpire() {
      this.$router.push(`/authen/?linkcode=${this.$route.query.linkcode}`)
    },
    getBanks() {
      if (this.$store.state.billBank) {
        let banks = this.$store.state.billBank
        this.selectedMethod = banks[0].paymentType
        this.billBankLength = banks.length
      }
    },

    async autoNext() {
      const linkcodes = this.$route.query.linkcode.split('?')
      this.$route.query.linkcode = linkcodes[0]
      await this.$store.dispatch('getBillData', {
        linkcode: this.$route.query.linkcode,
        page: 'paymentmethods',
      })
      try {
        if (!this.section && this.$store.state.billBank.length == 1) {
          let banks = this.$store.state.billBank
          this.selectedMethod = banks[0].paymentType
          this.set_section()
        }
      } catch (error) {
        this.autoNext()
      }
    },

    nextSkip() {
      if (this.billBank.length) {
        this.isExp = false
        let path = ''
        let banks = this.$store.state.billBank
        let selectedBank = banks.filter((bank) => {
          return bank.paymentType == this.selectedMethod
        })[0]
        if (selectedBank) {
          if (selectedBank.splitCard) {
            path = 'paymentInput'
          } else if (selectedBank.paymentType === 'SCB Easy') {
            path = 'scbeasy'
          } else {
            if (
              selectedBank.paymentType == 'CreditCard' ||
              selectedBank.paymentType == 'CreditUnion'
            ) {
              path = 'credit'
            } else {
              path = 'qr'
            }
            this.$store.commit('MAX_AMOUNT')
          }
          this.$store.commit('SELECTED_METHOD', selectedBank.id)
        }
        //NEW ACTION
        this.selectedMethod = selectedBank.paymentType
        this.set_section()
        //OLD ACTION
        // this.$router.push(
        //   `/${path}/${this.selectedMethod}/?linkcode=${
        //     this.$route.query.linkcode
        //   }`
        // )
      }
    },

    fullPaid() {
      this.amountCredit = this.total_price
      if (this.amountFloatCreditText) {
        this.amountCreditText = this.total_price + '.00'
        this.fncMaxLenFloat()
      } else {
        this.amountCreditToText()
      }
    },
    checkAmount() {
      if (
        parseFloat(this.amount) > this.total_price ||
        parseFloat(this.amount) < 0
      ) {
        this.amountCredit = this.total_price
      }
    },
    twoDecimal(val) {
      return parseFloat(val).toFixed(2)
    },
    genScbLink() {
      if (this.$store.state.billBank) {
        var bank = this.$store.state.billBank.filter((item) => {
          return item.paymentType == this.$route.params.method
        })
        if (bank.length > 0) {
          let qr = {}
          switch (this.$route.params.method) {
            case 'SCB Easy':
              this.method = 'SCB Easy'
              qr.trantype = 'S'
              break
          }
          qr.method = this.$route.params.method
          qr.refcode = this.$store.state.linkcode
          qr.amount = this.$store.state.amount
          qr.bubankid = bank[0].id
          this.$store.dispatch('getScbEasyLink', qr)
        }
      } else {
        this.changePaymentMethod()
      }
    },
    sendPayment() {
      this.checkAmount()
      let banks = this.$store.state.billBank.filter((res) => {
        return res.paymentType == this.selectedMethod
      })[0]
      let bubankid = banks.id
      let data = {
        linkcode: this.$route.query.linkcode,
        invoiceNo: this.$route.query.linkcode + '_' + new Date().getTime(),
        amount: this.amountCredit,
        description: 'ค่ารักษาพยาบาล',
        currencyCode: 'THB',
        paymentChannel: '',
        locale: 'th',
        tokenize: 'true',
        cardTokens: this.cardTokens,
        userDefined1: this.$route.query.linkcode,
        userDefined2: this.ref1,
        userDefined3: bubankid,
        userDefined4: '',
        userDefined5: '',
        frontendReturnUrl: '',
        backendReturnUrl: '',
        nonceStr: '' + new Date().getTime(),
      }
      this.$store.dispatch('getTwocTwopIntegrate', data).then(() => {})
    },

    sendDeeplink() {
      this.checkAmount()
      let banks = this.$store.state.billBank.filter((res) => {
        return res.paymentType == this.selectedMethod
      })[0]
      let bubankid = banks.id
      let orderNo = +new Date().getTime()
      let now = new Date()
      const requestDateTime = new Date(now)
      let data = {
        orderNo: orderNo,
        productDescription: 'Merchant orderNo ' + orderNo,
        currencyCode: 'THB',
        amount: this.amountCredit,
        amountText: this.set_amountText(),
        channelCode: 'DEEPLINK',
        agentCode: 'THSCB',
        confirmationURL: '',
        failedURL: '',
        cancellationURL: '',
        backendURL: '',
        title: '',
        firstName: this.custname,
        requestMessageID: '{3fd2e3e7-f5a9-4cee-5599-f0e7fffb995c}',
        requestDateTime: requestDateTime.toISOString(),
        language: 'en-US',
        userDefined1: this.$route.query.linkcode,
        userDefined2: this.ref1,
        userDefined3: bubankid,
      }
      this.$store.dispatch('getDeeplinkIntegrate', data).then(() => {})
    },
    set_amountText() {
      var tet_admount = String(this.amountCredit)
      if (this.amountCredit % 1 === 0) {
        tet_admount = tet_admount.padStart(10, '0') + '00'
      } else {
        tet_admount = tet_admount.split('.')
        tet_admount = tet_admount[0].padStart(10, '0') + tet_admount[1]
      }
      return tet_admount
    },

    async loadKBankScript() {
      //console.log('load kbank')
      let banks = this.$store.state.billBank.filter((res) => {
        return res.paymentType == this.selectedMethod
      })[0]

      let bubankid = banks.id
      //console.log('bubank ' + bubankid)

      await this.$store.dispatch('getbubankInfo', bubankid)
      try {
        if (this.$store.state.bubankInfo.length == 1) {
          let buBank = this.$store.state.bubankInfo
          this.apiKey = buBank[0].APIKey
          this.mid = buBank[0].mid
          this.service_id = buBank[0].service_id
          //console.log('key ' + this.apiKey)
          //console.log('mid ' + this.mid)
        }
      } catch (error) {}
      
      await this.$store.dispatch('getKcustomerInfo', {
        hn: this.ref1,
        mid: this.mid
      })

      try {
        if (this.$store.state.kcustomer.length == 1) {
          let kcustomerInfo = this.$store.state.kcustomer
          this.kcustomerID = kcustomerInfo[0].customerID
        }
      } catch (error) {}

      const container = this.$refs.kpayment
      container.innerHTML = '' // reset container
      this.haveCustomer = false;

      const script = document.createElement('script')
      script.onload = () => {
        if (this.$refs.kpayment.clientHeight == 0) {
          window.KPayment.create()
        }
      }
      script.type = 'text/javascript'
      script.src = process.env.VUE_APP_KPGW_JS_URL
      script.async = true
      //script.setAttribute('data-apikey', 'pkey_test_22424B1GmkDqR9enApdLlWVlWoJHmwiDFJPGg')
      script.setAttribute('data-apikey', this.apiKey)
      script.setAttribute('data-amount', this.amountCredit)
      script.setAttribute('data-currency', 'THB')
      script.setAttribute('data-payment-methods', 'card')
      script.setAttribute('data-name', this.shopName)
      //script.setAttribute('data-mid', '401925301025001')
      script.setAttribute('data-mid', this.mid)
      
      //if(this.kcustomerID != "" || this.kcustomerID != null){
      if(this.kcustomerID){
        script.setAttribute('data-customer-id', this.kcustomerID)
        this.haveCustomer = true;
      }

      if(this.selectedMethod == 'KSmartPay'){
        script.setAttribute('data-smartpay-id', this.service_id || '0002')
      }

      container.appendChild(script)

      // เริ่มจับ token ด้วย MutationObserver
      this.observeToken(container)
    },

    observeToken(container) {
      const observer = new MutationObserver(() => {
        const tokenInput = container.querySelector('input[name="token"]')
        if (tokenInput) {
          const token = tokenInput.value
          //console.log('Token ถูกสร้างแล้ว:', token)

          this.paymentToken = token
          this.paymentResponse = { token }

          let banks = this.$store.state.billBank.filter((res) => {
            return res.paymentType == this.selectedMethod
          })[0]
          let bubankid = banks.id

          //เช็ค saveCard (มี input นี้หรือไม่)
        const saveCardInput = container.querySelector('input[name="saveCard"]')
        const isSaveCard = !!saveCardInput   // true ถ้ามี, false ถ้าไม่มี

        //check smartpay
        const smartPayID = container.querySelector('input[name="smartpayId"]')
        const smartPayTerm= container.querySelector('input[name="term"]')

          // ส่งไป backend เพื่อสร้าง Charge
          let data = {
            linkcode: this.$route.query.linkcode,
            reference_order:
              this.$route.query.linkcode + '_' + new Date().getTime(),
            amount: this.amountCredit,
            source_type: 'card',
            description: 'ค่ารักษาพยาบาล',
            currencyCode: 'THB',
            token: this.paymentToken,
            bubankid: bubankid,
            ...(isSaveCard && { saveCard: saveCardInput.value }),
            ...(this.haveCustomer && { customer_id: this.kcustomerID }),
            ...(smartPayID && { smartpay_id: smartPayID.value }),
            ...(smartPayTerm && { smartpay_term: smartPayTerm.value })
          }
           //console.log('Charge Data: ', data)
          this.$store.dispatch('getKbankCreateCharge', data).then(() => {})

          observer.disconnect() // เจอแล้วก็หยุด observe
        }
      })

      observer.observe(container, { childList: true, subtree: true })
    },

    //Kbank Alipay 
    sendCreateCharge(){

      let banks = this.$store.state.billBank.filter((res) => {
          return res.paymentType == this.selectedMethod
      })[0]
      let bubankid = banks.id
      // ส่งไป backend เพื่อสร้าง Charge
      let data = {
        linkcode: this.$route.query.linkcode,
        reference_order:
          this.$route.query.linkcode + '_' + new Date().getTime(),
        amount: this.amountCredit,
        source_type: 'alipay',
        description: 'ค่ารักษาพยาบาล',
        currencyCode: 'THB',
        bubankid: bubankid
      }
        //console.log('Charge Data: ', data)
      this.$store.dispatch('getKbankCreateCharge', data).then(() => {})

    },

    //Appswitch
    sendAppswitch(){

      let banks = this.$store.state.billBank.filter((res) => {
          return res.paymentType == this.selectedMethod
      })[0]
      let bubankid = banks.id
      // ส่งไป backend เพื่อสร้าง Charge
      let data = {
        linkcode: this.$route.query.linkcode,
        reference_order:
          this.$route.query.linkcode + '_' + new Date().getTime(),
        amount: this.amountCredit,
        source_type: 'appswitch_other',
        description: 'ค่ารักษาพยาบาล',
        currencyCode: 'THB',
        bubankid: bubankid
      }
        //console.log('Charge Data: ', data)
      this.$store.dispatch('getKbankCreateCharge', data).then(() => {})

    },

    async loadWechatPaynow(){

      let banks = this.$store.state.billBank.filter((res) => {
          return res.paymentType == this.selectedMethod
      })[0]
      let bubankid = banks.id

      let referenceorder = this.$route.query.linkcode + '_' + new Date().getTime()

      // ส่งไป backend เพื่อสร้าง Order
      let data = {
        linkcode: this.$route.query.linkcode,
        reference_order: referenceorder,
        amount: this.amountCredit,
        source_type: 'wechat',
        description: 'ค่ารักษาพยาบาล',
        currencyCode: 'THB',
        bubankid: bubankid
      }

      await this.$store.dispatch('getKbankCreateOrder', data)

      try {
        if (this.$store.state.kbankOrderInfo) {
          let kbankOrderInfo = this.$store.state.kbankOrderInfo
          this.kOrderID = kbankOrderInfo.id
        }
      } catch (error) {}

      await this.$store.dispatch('getbubankInfo', bubankid)
      try {
        if (this.$store.state.bubankInfo.length == 1) {
          let buBank = this.$store.state.bubankInfo
          this.apiKey = buBank[0].APIKey
          this.mid = buBank[0].mid
        }
      } catch (error) {}

      this.billStatus = setInterval(() => {
        if (this.$route.name == 'paymentMethods') {
          this.$store
            .dispatch('getBillDataStatus', this.$route.query.linkcode)
            .then(() => {
              if (this.$store.state.billDataStatus > 2) {
                let page =
                  this.$store.state.billDataStatus <= 3
                    ? 'paymentMethods'
                    : // : 'billRecieve'
                      'paymentSuccess'
                clearInterval(this.billStatus)
                this.$router.push(
                  `/${page}/?linkcode=${this.$route.query.linkcode}`
                )
              }
            })
        }
      }, 15000)

      const container = this.$refs.kpaywechat
      container.innerHTML = '' // reset container

      const script = document.createElement('script')
      script.onload = () => {
        if (this.$refs.kpaywechat.clientHeight == 0) {
          window.KPayment.create()

          window.KPayment.onClose(() => {
            if (this.billStatus) {
              clearInterval(this.billStatus)
              this.billStatus = null
            }
          })
        }
      }

      script.type = 'text/javascript'
      script.src = process.env.VUE_APP_KPGW_JS_URL
      script.async = true
      script.setAttribute('data-apikey', this.apiKey)
      script.setAttribute('data-amount', this.amountCredit)
      script.setAttribute('data-payment-methods', 'wechat')
      script.setAttribute('data-name', this.shopName)
      script.setAttribute('data-mid', this.mid)
      script.setAttribute('data-ref-number', referenceorder)
      script.setAttribute('data-order-id', this.kOrderID)

      container.appendChild(script)

    },

    //Fix Check Expire
    checkExpireNow() {
      const exp = moment(this.$store.state.expire).toDate()

      if (exp.getTime() <= Date.now()) {
        this.$router.push(`/paymentExpired/?linkcode=${this.$route.query.linkcode}`)
        return true
      }
      return false
    },

    async loadInstallmentBanks() {
      const installBank =
        this.$store.state.billBank.find(
          item =>
            item.paymentType ==
            this.selectedMethod
        )

      if (!installBank) {
        return
      }

      await this.$store.dispatch(
        'getInstallmentBanks',
        installBank.id
      )

      this.installmentBanks =
        this.$store.state.installmentBanks
    },
    getSelectedTerms() {

      const bank =
        this.installmentBanks.find(
          item =>
            item.bank_code ===
            this.selectedInstallmentBank
        )

      if (!bank) {
        return []
      }

      return JSON.parse(
        bank.installment_terms
      )
    },
    async loadAppswitchBanks() {
      const appswitchBank =
        this.$store.state.billBank.find(
          item =>
            item.paymentType ==
            this.selectedMethod
        )

      if (!appswitchBank) {
        return
      }

      await this.$store.dispatch(
        'getAppswitchBanks',
        appswitchBank.id
      )

      this.appswitchBanks =
        this.$store.state.appswitchBanks
    },
    getInstallmentLogo(bankCode) {
      const logos = {
        bbl: require('../assets/bank_logo_bbl.png'),
        bay: require('../assets/bank_logo_bay.png'),
        firstchoice: require('../assets/bank_logo_firstchoice.png'),
        scb: require('../assets/bank_logo_scb.png'),
        ktc: require('../assets/bank_logo_ktc.png'),
        ttb: require('../assets/bank_logo_ttb.png'),
        uob: require('../assets/bank_logo_uob.png'),
      }

      return logos[bankCode] || ''
    },
    getAppswitchLogo(bankCode) {
      const logos = {
        bbl: require('../assets/bank_logo_bbl.png'),
        bay: require('../assets/bank_logo_bay.png'),
        scb: require('../assets/bank_logo_scb.png'),
        ktb: require('../assets/bank_logo_ktb.png')
      }

      return logos[bankCode] || ''
    }

  },
  computed: {
    qrcode() {
      if (!this.$store.state.qr) return require('@/assets/no_img.png')
      return this.$store.state.qr
    },

    ...mapState({
      billBank: (state) => state.billBank,
    }),
    titlePaymentType() {
      return this.$options.filters.dbTextDisplay('PaymentType')
    },

    language() {
      return this.$store.state.language
    },
    payment_methods() {
      if (this.$store.state.billBank) {
        let banks = this.$store.state.billBank
        let isiOS =
          navigator.userAgent.match('iPad') ||
          navigator.userAgent.match('iPhone') ||
          navigator.userAgent.match('iPod')
        let isAndroid = navigator.userAgent.match('Android')
        banks.forEach((bank) => {
          bank.disabled = false
          if (this.$store.state.language == 'EN') {
            bank.description = bank.description_en
          } else {
            bank.description = bank.description_th
          }
          switch (bank.paymentType) {
            case 'CreditCard':
              bank.icon = `<img src="${require('../assets/icon-card.png')}"/>`
              break
            case 'KCreditCard':
              bank.icon = `<img src="${require('../assets/icon-card-k.png')}"/>`
              break
            case 'CreditUnion':
              bank.icon = `<img src="${require('../assets/icon-unionpay.png')}"/>`
              break
            case 'CreditQR':
            case 'KCreditQR':
              bank.icon_qr_credit = `<img src="${require('../assets/credit-qr-1.png')}"/>`
              bank.icon = `<img src="${require('../assets/icon-qr.png')}"/>`
              break
            case 'ThaiQR':
            case 'KThaiQR':
              //bank.icon = `<img src="${require('../assets/icon-qr-payment.png')}" />`
              //bank.icon = `<img src="${require('../assets/icon-qr-payment-v2.png')}" />`

              // Current UAT
              bank.icon = `<img src="${require('../assets/icon-thai-qr-cross-v1.png')}" /> `

              //bank.icon = `<img src="${require('../assets/icon-qr-payment-v2.png')}" />`

              break
            case 'WeChat':
            case 'KWeChat':
              bank.icon = `<img src="${require('../assets/icon-wechat.png')}"/>`
              break
            case 'Alipay':
            case 'KAlipay':
              bank.icon = `<img src="${require('../assets/icon-alipay.png')}" />`
              break
            case 'AlipayPlus':
              bank.icon = `<img src="${require('../assets/icon-alipay-plus.png')}" />`
              break
            case 'SCB Easy':
              bank.disabled = !(isiOS || isAndroid)
              bank.icon = `<img src="${require('../assets/ic_scb_easy.png')}" />`
              break
            case 'MobileBanking':
              bank.disabled = !(isiOS || isAndroid)
              bank.icon = `<img src="${require('../assets/icon-bank.png')}"/>`
              break
            //Add PayPlus 04/02/26
            case 'PayPlus':
              bank.disabled = !(isiOS || isAndroid)
              bank.icon = `<img src="${require('../assets/new-k-plus-logo.png')}" style=" width:auto;"/>`
              break
            case 'PPCS':
              bank.icon = `<img src="${require('../assets/icon-thai-qr-cross-v1.png')}" /> <img src="${require('../assets/icon-qr.png')}"/>`
              bank.icon_qr_credit = `<img src="${require('../assets/icon-thai-qr-cross-v1.png')}" /> <img src="${require('../assets/credit-qr-1.png')}"/>`
              break
            //Add Kbank SmartPay 29/05/26
            case 'KSmartPay':
              bank.icon = `<img src="${require('../assets/logo_kbank_smartpay.png')}"/>`
              break
            case 'AppswitchCrossbank':
              //bank.disabled = !(isiOS || isAndroid)
              bank.icon = `<img src="${require('../assets/icon-bank-appswitch.png')}"/>`
              break
          }
        })
        return banks
        // return banks.filter(res=>{ return res.paymentType != 'MobileBanking'})
      } else {
        return []
      }
    },
    isSplitPaid() {
      if (
        this.$store.state.billData &&
        this.$store.state.billData.paid > 0 &&
        this.$store.state.billData.outstanding > 0
      ) {
        return true
      } else {
        return false
      }
    },
    route() {
      if (this.$store.state.billBank) {
        let path = ''
        let banks = this.$store.state.billBank
        let selectedBank = banks.filter((bank) => {
          return bank.paymentType == this.selectedMethod
        })[0]
        if (selectedBank) {
          if (selectedBank.splitCard) {
            path = 'paymentInput'
          } else if (selectedBank.paymentType === 'SCB Easy') {
            path = 'scbeasy'
          } else if(selectedBank.paymentType === 'PayPlus'){
            path = 'payplus'
          } else {
            if (
              selectedBank.paymentType == 'CreditCard' ||
              selectedBank.paymentType == 'CreditUnion'
            ) {
              path = 'credit'
            } else {
              path = 'qr'
            }
            this.$store.commit('MAX_AMOUNT')
          }
          this.$store.commit('SELECTED_METHOD', selectedBank.id)
        }
        return `/${path}/${this.selectedMethod}/?linkcode=${this.$route.query.linkcode}`
      }
      return '/'
    },

    text() {
      let obj = {}
      //console.log('Lang : ' + this.$store.state.language)
      if (this.$store.state.language == 'TH') {
        obj = {
          paymentType: 'เลือกวิธีชำระเงิน',
          nextButton: 'ดำเนินการต่อ',
          linkExp: 'ลิงค์ชำระเงินนี้หมดอายุแล้ว',
          paymentBy: 'ชำระเงินผ่าน',
          changePaymentMethod: 'เปลี่ยนวิธีการชำระเงิน',
          btndownloadQR: 'บันทึกคิวอาร์',
          Total: 'ยอดรวม',
          amountTotal: 'ยอดที่ระบุ',
          outstanding: 'คงเหลือ',
          headQr: 'กรุณาสแกนคิวอาร์ เพื่อชําระเงิน',
          headQrdesc:
            'โปรดรอซักครู่ กรุณาอย่าปิดเบราว์เซอร์ หรือทําการรีเฟรช หน้าจอหลังชําาระเงินแล้ว ระบบจะทําการพาคุณกลับสู่หน้าหลัก',
          headCredit: 'ระบุจำนวนเงินที่ต้องชำระ',
          headCreditdesc: '(ท่านสามารถทำรายการด้วยบัตรมากกว่า 1 ใบได้)',
          fullpaid: 'ชำระเต็มจำนวน',
          selectBank: 'เลือกธนาคาร',
          selectTerm: 'เลือกจำนวนงวด',
          installmentMonth: 'งวด',
          installmentVia: 'ผ่อนผ่าน',
        }
      } else {
        obj = {
          paymentType: 'Payment Type',
          nextButton: 'Next',
          linkExp: 'This link expire.',
          paymentBy: 'Pay through',
          changePaymentMethod: 'Change payment method',
          btndownloadQR: 'Save QR ',
          Total: 'Total ',
          amountTotal: 'Amount ',
          outstanding: 'Outstanding',
          headQr: 'Please scan the QR. to pay',
          headQrdesc:
            'Please wait a moment. Please do not close the browser. or refresh Screen after payment The system will take you back to the home page. ',
          headCredit: 'Specific the amount to pay',
          headCreditdesc: '(You can make transactions with more than 1 card.)',
          fullpaid: 'Pay in full',
          selectBank: 'Select Bank',
          selectTerm: 'Select Installment Term',
          installmentMonth: 'Months',
          installmentVia: 'Installment via',
        }
      }
      return obj
    },

    total() {
      return this.twoDecimal(this.$store.state.total)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    amount() {
      return this.twoDecimal(this.$store.state.amount)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },

    amountCredit: {
      get() {
        return this.$store.state.amount
      },
      set(newValue) {
        newValue = parseFloat(newValue)
        if (!newValue) newValue = 0
        if (newValue > this.minPay.amount) {
          this.minPay.disabled = false
        } else {
          this.minPay.disabled = true
        }
        this.$store.dispatch('changeAmount', newValue)
      },
    },

    custname() {
      return this.$store.state.name
    },
    total_price() {
      return this.$store.state.outstanding
    },
    outstanding() {
      return this.$store.state.outstanding - this.$store.state.amount
    },
    outstanding_Decimal() {
      return this.twoDecimal(
        this.$store.state.outstanding - this.$store.state.amount
      )
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    cardTokens() {
      return this.$store.state.cardTokens
    },
    ref1() {
      return this.$store.state.ref1
    },
    selectedInstallmentBankInfo() {
      return this.installmentBanks.find(
        bank => bank.bank_code === this.selectedInstallmentBank
      )
    }
  },

  watch: {
    amountCredit(newVal, oldVal) {
      //console.log('Amount changed from', oldVal, 'to', newVal)
      if (this.selectedMethod === 'KCreditCard' || this.selectedMethod === 'KSmartPay') {
        if (window.KPayment) {
          window.KPayment.setAmount(newVal)
        }
      }
    },
  },
}
</script>
